import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=066a4ec2&scoped=true&"
import script from "./InputSearch.vue?vue&type=script&lang=ts&"
export * from "./InputSearch.vue?vue&type=script&lang=ts&"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=066a4ec2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a4ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066a4ec2')) {
      api.createRecord('066a4ec2', component.options)
    } else {
      api.reload('066a4ec2', component.options)
    }
    module.hot.accept("./InputSearch.vue?vue&type=template&id=066a4ec2&scoped=true&", function () {
      api.rerender('066a4ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/input/InputSearch.vue"
export default component.exports